export const noteFieldName = 'note';
